import CustomForm from '../Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../Util/Form/CustomForm/CustomFormContainer';
import config from '../../../../application/config/config';

function Form() {

    const path = '/core/applications/';

    const paths = {
        endpointSave: config.endpoints.backend+'core/applications/save',
        endpointGetById: config.endpoints.backend+'core/applications/getById',
        urlGoBack: path+'list',
        pathView: path+'view',
    }

    const labels = {
        labelTitleAdd:  "Nova Aplicação",
        labelTitleEdit: "Editar Aplicação",
        labelTitleView: 'Visualizar Aplicação'
    }
    
    const form = {
        validateOnChange: true,
        fields: [
            {
                name: 'application_name',
                type: 'text',
                label: 'Nome da aplicação',
                validations: {
                    required: true
                },
                columnSize: 12
            }
        ],
        ...paths,
        ...labels
    }

    return (
        <div>
            <CustomFormContainer 
                form = {form}
                content = {<CustomForm form={form} />}
            />
        </div>
    );
}
export default Form;
